import React, {Component} from "react";
import {UncontrolledTooltip} from "reactstrap";
import {Formik, Form, Field} from "formik";
import {Badge, Button} from "reactstrap";
import {Link} from "react-router-dom";
import swal from "sweetalert";
import CircleLoader from "react-spinners/CircleLoader";
import DatePicker from "react-datepicker/es";
import OETModalHistory from "./oet_history_modal.component";
import {service as oetService} from "../redux";
import {service as cpoService} from "../../cpo/redux";
import {utils} from "~/utils";
import "react-datepicker/dist/react-datepicker.css";
import "./tracker_filter.scss";
// import * as _ from "lodash";
import AsyncSelect from "react-select/async";
import UploadFileModal from "../../../sode/cpo/components/upload_file_modal.component";
import ReuploadOfflineApproval from "./reupload_offline_approval.component";

const initValues = (oet, run, pr_approved_date) => {
    let res = {
        number: "",
        issuing_date: "",
        bp_open_work_order_ref_number: "",
        purchasing_group: "",
        name: "",
        for_offer_number_created_in_csp: "",
        sap_top_wbs: "",
        so_count: "",
        vpo_count: "",
        base_id: "",
        pr_approved_date: "",
        account_indicator: "",
        expired_days: "",
        wbs_expiry_date: '',
    };
    if (oet) {
        const {cpo_data} = oet;
        if (oet && cpo_data) {
            let {number} = cpo_data;
            number = `${number}`;
            const id = oet.issuing_date;
            const boworn = oet.bp_open_work_order_ref_number;
            const pg = oet.purchasing_group;
            const name = oet.name ? oet.name : "";
            const foncic = oet.for_offer_number_created_in_csp;
            const stwbs = oet.sap_top_wbs;
            const wbs_expiry_date = oet.wbs_expiry_date ? oet.wbs_expiry_date : ''
            res = {
                ...res,
                name,
                number,
                issuing_date: utils.renderDate(id),
                bp_open_work_order_ref_number: boworn ? boworn : "",
                purchasing_group: pg ? pg : "",
                for_offer_number_created_in_csp: foncic ? foncic : "",
                sap_top_wbs: stwbs ? stwbs : "",
                expired_days: oet.customer_purchase_order.expired_days,
                wbs_expiry_date: utils.renderDate(wbs_expiry_date) ? oet.wbs_expiry_date : '',
            };
        }
    }
    if (run) {
        const {so_count, vpo_count, base_id, account_indicator} = run;
        res = {
            ...res,
            ...(so_count !== null ? {so_count} : {}),
            ...(vpo_count !== null ? {vpo_count} : {}),
            base_id: base_id ? base_id : "",
            pr_approved_date: pr_approved_date ? pr_approved_date : "",
            account_indicator: account_indicator ? {
                value: account_indicator.id,
                label: account_indicator.description
            } : null
        };
    }
    return res;
};

export default class Basic extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: null,
            loading_oet_report: false,
            pr_approved_date: null,
            button_10_title: (this.props.run && this.props.run.bulk_line_limit_quantity !== 10 ? "Put" : "Remove") + ' 10 quantity limit',
            loading_offline_approval: false,
        };
    }
    upload_file_modal = React.createRef();

    static header = (collapse, props) => {
        const {oet, run} = props;
        let status_display = "";
        let newVal = "";
        let type_flow_display = ""
        if (run) {
            status_display = run.status_display;
            type_flow_display = run.type_flow_display
            switch (run.action) {
                case "partial_cancel":
                    newVal = "Partially Cancel";
                    break;
                case "amend":
                    newVal = "Amend";
                    break;
                default:
                    break;
            }
        } else if (oet) {
            status_display = oet.status_display;
            type_flow_display = oet.type_flow;
        }
        return (
            <nav className="navbar">
                <span className="navbar-brand h4">{run ? "OET Info" : "Cpo Tracker"}</span>
                <div>
                    {oet && run && run.original_run && (
                        <span style={{margin: "0 8px"}}>
                            Original Run ID:{" "}
                            <Link to={`/run/${oet.id}/${run.original_run.id}`}>Run #{run.original_run.number}</Link>
                        </span>
                    )}
                    {run && run.original_run && (
                        <span style={{margin: "0 8px"}}>
                            Creation: <Badge color="primary">{newVal}</Badge>
                        </span>
                    )}
                    <span>
                        Status: <Badge color="info">{status_display}</Badge>
                    </span>
                    {run && (
                        <span style={{marginLeft: "8px"}}>
                        Process: {oet && <Badge>{type_flow_display}</Badge>}
                    </span>
                    )}
                </div>
            </nav>
        );
    };

    componentDidMount = () => {
        if (this.props.run){
            this.setState({
                file: this.props.run.offline_approval.file ? this.props.run.offline_approval.file.split("/").pop() : null
            })
        }
    }

    open_modal = () => {
        if (this.upload_file_modal.current) {
            this.upload_file_modal.current.toggle();
        }
    };

    approveOfflineApproval(){
        const {run} = this.props
        return cpoService
            .approveOfflineApproval(run.id)
            .then(response => {
                swal({
                    title: "Success",
                    text: "File approved successfully",
                    icon: "success",
                    button: "true"
                })
            })
            .catch(error=>{
                swal({
                    title: "Error!",
                    text: utils.computeError(error),
                    icon: "error",
                    button: true
                });
            })
    }


    sendOfflineApproval = (file) => {
        const {run} = this.props
        const data = new FormData()
        data.append('file', file)
        data.append('object_id', run.id)
        data.append('content_type', 21)
        this.setState({ loading: true });
        return cpoService
            .sendFile(data, run.offline_approval.id)
            .then((response_data) => {
                this.setState({file: response_data.file_name})
                swal({
                    title: "Success",
                    text: 'File uploaded successfully',
                    icon: "success",
                    button: true
                });
            })
            .catch(error => {
                swal({
                    title: "Error!",
                    text: utils.computeError(error),
                    icon: "error",
                    button: true
                });
            });
    };

    openComments = () => {
        const {run, user, commentsModal} = this.props;
        commentsModal.toggle({
            requestData: {
                content_type: 21,
                object_id: run.id,
                user
            },
            withOnSend: false
        });
    };

    get_pr_approved_date = run => {
        if (run) {
            const {pr_approved_date} = run;
            let date = null;
            if (pr_approved_date) {
                date = this.state.pr_approved_date ? this.state.pr_approved_date : utils.strToDate(pr_approved_date);
            }
            return date;
        }
        return null;
    };

    on_click_sync_wbs = (oet, run) => {
        const {syncWbs} = this.props;
        syncWbs(oet.id, run.id, (success, data) => {
            let type = "warning";
            let mgs = data.message;
            if (success && data) {
                type = "success";
            }
            if (!success && data) {
                type = "warning";
            }
            swal({
                title: "Sync WBS",
                text: mgs,
                icon: type,
                button: true
            });
        });
    };

    change_quantity_limit_callback = (success, data) => {
        let type = "warning";
        let mgs = data.detail;
        if (success && data) {
            type = "success";
            const button_10_title = (data.bulk_line_limit_quantity === 10 ? 'Remove' : 'Put') + ' 10 quantity limit'
            this.setState({button_10_title})
        }
        if (!success && data) {
            type = "warning";
        }
        swal({
            title: "Change 10 quantity limit",
            text: mgs,
            icon: type,
        });
    }

    load_options_account_indicator = (search) => {
        return oetService.getAccountIndicators(search)
            .then(resp => resp.list.map(account_indicator => {
                    return {
                        value: account_indicator.id,
                        label: account_indicator.description
                    };
                })
            );
    };

    downloadOfflineApproval = (e, file_name) => {
        const content_type = 21;
        const {run} = this.props
        this.setState({
            loading_offline_approval: !this.state.loading_offline_approval,
        })
        cpoService.downloadOfflineApproval(content_type, file_name, run.id).then(
            this.setState({loading_offline_approval: false})
        ).catch(error => {
            swal({
                title: "Error",
                text: utils.computeError(error),
                icon: 'error',
            });
            this.setState({loading_offline_approval: false})
        }
        )
        e.preventDefault();
      };

    render() {
        const {oet, run, status, syncQuantityContract, startPRValidation, syncVoa, onSubmit, onCancel, changeQuantityLimit} = this.props;
        const pr_approved_date = this.get_pr_approved_date(run);
        const init_values = initValues(oet, run, pr_approved_date)
        const cpo_register = oet ? oet.customer_purchase_order : null
        let file = this.state.file;
        return (
            <div className={["tracker_filters", this.props.className].join(" ")}>
                <UploadFileModal
                    onSubmit={this.sendOfflineApproval}
                    ref={this.upload_file_modal}
                />
                <div className="content">
                    <Formik
                        initialValues={init_values}
                        enableReinitialize={true}
                        onSubmit={(values, cmp) => this.handleSubmit(onSubmit, values, cmp)}
                    >
                        {formik => {
                            return (
                                <Form>
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-md-4">
                                            <label>CPO Number</label>
                                            <Field name="number" type="text" disabled className="form-control"/>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-4">
                                            <label>OET Issuing Date</label>
                                            <Field name="issuing_date" type="text" disabled className="form-control"/>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-4">
                                            <div className="form-group">
                                                <label>BPOpen Work Order ref. number</label>
                                                <Field
                                                    name="bp_open_work_order_ref_number"
                                                    type="text"
                                                    className="form-control"
                                                    disabled={!run ? status > 1 : status > 0}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-md-4">
                                            <div className="form-group">
                                                <label>Purchasing group</label>
                                                <Field
                                                    name="purchasing_group"
                                                    type="text"
                                                    className="form-control"
                                                    disabled={!run ? status > 1 : status > 0}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-4">
                                            <div className="form-group">
                                                <label>OET Name</label>
                                                <Field
                                                    name="name"
                                                    type="text"
                                                    className="form-control"
                                                    disabled={!run ? status > 1 : status > 0}
                                                />
                                            </div>
                                        </div>
                                        {status >= 0 && (
                                            <div className="col-12 col-sm-12 col-md-4">
                                                <div className="form-group">
                                                    <label>SAP Top WBS</label>
                                                    <Field
                                                        name="sap_top_wbs"
                                                        type="text"
                                                        className="form-control"
                                                        disabled={run || status > 1}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {status >= 0 && (
                                        <div className="row">
                                            {run && (
                                                <div className="col-12 col-sm-12 col-md-4">
                                                    <div className="form-group">
                                                        <label>SO Count</label>
                                                        <Field
                                                            name="so_count"
                                                            type="number"
                                                            min={0}
                                                            step={1}
                                                            className="form-control"
                                                            disabled={status > 1}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {run && (
                                                <div className="col-12 col-sm-12 col-md-4">
                                                    <div className="form-group">
                                                        <label>VPO Count</label>
                                                        <Field
                                                            name="vpo_count"
                                                            type="number"
                                                            min={0}
                                                            step={1}
                                                            className="form-control"
                                                            disabled={status > 1}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {status >= 1 && (
                                                <div className="col-12 col-sm-12 col-md-4">
                                                    <div className="form-group">
                                                        <label>For offer number created in CSP</label>
                                                        <Field
                                                            name="for_offer_number_created_in_csp"
                                                            type="text"
                                                            className="form-control"
                                                            disabled={
                                                                status > 2 ||
                                                                (run && status === 1 && run.paid_foc !== "partial")
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {status >= 0 && (
                                                <div className="col-12 col-sm-12 col-md-4">
                                                    <div className="form-group">
                                                        <label>WBS expiry date</label>
                                                        <Field name="wbs_expiry_date" type="text" disabled className="form-control"/>
                                                    </div>
                                                </div>
                                            )}
                                            {status >= 4 && run && (
                                                <div className="col-12 col-sm-12 col-md-4">
                                                    <div className="form-group">
                                                        <label>BASE ID</label>
                                                        <Field
                                                            name="base_id"
                                                            type="text"
                                                            min={0}
                                                            step={1}
                                                            className="form-control"
                                                            disabled={status !== 4}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {run && (
                                                <div className="col-12 col-sm-12 col-md-4">
                                                    <div className="form-group">
                                                        <label>PR approved date</label>
                                                        {run.pr_validation && run.pr_validation.full_message && (
                                                            <React.Fragment>
                                                                <i
                                                                    className="fas fa-info-circle"
                                                                    id="div-pr_approved_date"
                                                                ></i>
                                                                <UncontrolledTooltip
                                                                    placement="right"
                                                                    target="div-pr_approved_date"
                                                                >
                                                                    <div>{run.pr_validation.full_message}</div>
                                                                </UncontrolledTooltip>
                                                            </React.Fragment>
                                                        )}
                                                        <Field
                                                            component={DatePicker}
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            name="pr_approved_date"
                                                            onChange={value =>
                                                                formik.setFieldValue("pr_approved_date", value, false)
                                                            }
                                                            selected={formik.values.pr_approved_date}
                                                            disabled={status !== 5}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {run && (
                                                <div className="col-12 col-sm-12 col-md-4">
                                                    <div className="form-group">
                                                        <label>Account Indicator</label>
                                                        <Field
                                                            name="account_indicator"
                                                            component={AsyncSelect}
                                                            isClearable
                                                            cacheOptions
                                                            defaultOptions
                                                            defaultValue={init_values.account_indicator}
                                                            disabled={status !== 4}
                                                            loadOptions={val => this.load_options_account_indicator(val)}
                                                            onChange={val => formik.setFieldValue("account_indicator", val, false)}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {run && file && utils.check_validation_type(cpo_register) &&(
                                            <div className="col-12 col-sm-12 col-md-4">
                                                <div className="form-group">
                                                    <label>Offline approval</label>
                                                    <div>
                                                        <Button 
                                                            onClick={(e) => this.downloadOfflineApproval(e, file)} 
                                                            color="link">
                                                                {file}
                                                        </Button>
                                                        <CircleLoader
                                                            loading={this.state.loading_offline_approval}
                                                            color={"#007bff"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        </div>
                                    )}
                                    <div className="row controls">
                                        {!run && (
                                            <Button
                                                color="danger"
                                                type="button"
                                                onClick={ev => {
                                                    onCancel();
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        )}
                                        <div style={{flex: "1 0 auto"}}/>
                                        {
                                            oet && run && status === 1 && utils.check_validation_type(cpo_register) ? 
                                            <ReuploadOfflineApproval run={run} oet={oet} open_modal={this.open_modal}/> : 
                                                null
                                        }
                                        {run && oet && (
                                            <React.Fragment>
                                                <Button
                                                    icon="download"
                                                    color="primary"
                                                    type="button"
                                                    onClick={ev => {
                                                        if (oet) {
                                                            this.setState({loading_oet_report: true});
                                                            oetService.download(run, oet).then(response => {
                                                                this.setState({loading_oet_report: false});
                                                            });
                                                        }
                                                    }}
                                                >
                                                    Download OET
                                                </Button>
                                                <CircleLoader
                                                    loading={this.state.loading_oet_report}
                                                    color={"#007bff"}
                                                />
                                            </React.Fragment>
                                        )}
                                        {run && oet && status === 5 && (
                                            <Button
                                                color="primary"
                                                type="button"
                                                title={run.disable_pr_action}
                                                disabled={run.disable_pr_action}
                                                onClick={ev => {
                                                    startPRValidation(
                                                        oet.id,
                                                        run.id,
                                                        run.pr_validation.id,
                                                        (success, data) => {
                                                            let mgs = data.detail;
                                                            let buttons = {close: "Ok"};
                                                            swal({
                                                                title: "PR Validation",
                                                                text: mgs,
                                                                icon: data.type,
                                                                buttons: buttons
                                                            });
                                                        }
                                                    );
                                                }}
                                            >
                                                Start PR Validation
                                            </Button>
                                        )}
                                        {!run && oet && <OETModalHistory oet_logs={oet.state_logs}/>}
                                        {run && <OETModalHistory oet_logs={run.state_logs}/>}
                                        {(status === 0 || status === 1 || status === 2 || status === 4 || status === 5) && onSubmit && (
                                            <Button color="primary" type="submit">
                                                Save
                                            </Button>
                                        )}
                                        {run && run.type_flow === 'sode_bulk' && (status === 0 || status === 1 || status === 2 || status === 4 || status === 5) && (
                                            <Button color="primary" type="button" onClick={ev => {
                                                changeQuantityLimit(oet.id, run.id, this.change_quantity_limit_callback)
                                            }}>
                                                {this.state.button_10_title}
                                            </Button>
                                        )}
                                        {status === 4 && (
                                            <React.Fragment>
                                                <Button
                                                    color="primary"
                                                    type="button"
                                                    onClick={ev => {
                                                        oetService.requestJob(run.id, oet.quantity_contract_number)
                                                            .then(res => {
                                                                if (res && res.detail) {
                                                                    swal({
                                                                        title: "Sync QC from SAP",
                                                                        text: res.detail,
                                                                        icon: "success"
                                                                    });
                                                                }
                                                            })
                                                            .catch(error => console.log({...error}));
                                                    }}
                                                >
                                                    Sync QC from SAP
                                                </Button>
                                                <Button
                                                    color="primary"
                                                    type="button"
                                                    onClick={ev => {
                                                        syncQuantityContract(oet.id, run.id, (success, data) => {
                                                            let type = "warning";
                                                            let mgs = data.detail;

                                                            if (success && data) {
                                                                type = "success";
                                                            }
                                                            if (!success && data) {
                                                                type = "warning";
                                                            }

                                                            let buttons = {close: "Ok"};
                                                            if (!data.sync_all && data.media_url) {
                                                                buttons = {download_report: "Download", close: "Ok"};
                                                                mgs = mgs + '.\nIf you want to know, why this sync not was done 100%, please do click on button "Download" to get a file';
                                                                mgs = mgs + ".\nThis file show how ZINA made the blocks (groups) to file the lines";
                                                            }
                                                            swal({
                                                                title: "Sync Quantity Contract",
                                                                text: mgs,
                                                                icon: type,
                                                                buttons: buttons
                                                            }).then(button => {
                                                                switch (button) {
                                                                    case "download_report":
                                                                        const link = document.createElement("a");
                                                                        link.href = data.media_url;
                                                                        document.body.appendChild(link);
                                                                        link.click();
                                                                        document.body.removeChild(link);
                                                                        break;
                                                                    default:
                                                                        break;
                                                                }
                                                            });
                                                        });
                                                    }}
                                                >
                                                    Sync Quantity Contract
                                                </Button>
                                                {run.type_flow !== "sode_bulk" && (
                                                    <Button
                                                        title={run.disable_sync_wbs ? "This button was disabled cause Site WBS element already was filled" : "Sync WBS"}
                                                        disabled={run.disable_sync_wbs}
                                                        color="primary"
                                                        type="button"
                                                        onClick={ev => {
                                                            this.on_click_sync_wbs(oet, run);
                                                        }}
                                                    >
                                                        Sync WBS
                                                    </Button>
                                                )}
                                                <Button
                                                    color="primary"
                                                    type="button"
                                                    onClick={ev => {
                                                        syncVoa(oet.id, run.id, (success, data) => {
                                                            let type = "warning";
                                                            let mgs = data.message;
                                                            if (success && data) {
                                                                type = "success";
                                                            }
                                                            if (!success && data) {
                                                                type = "warning";
                                                            }
                                                            swal({
                                                                title: "Sync VOA",
                                                                text: mgs,
                                                                icon: type,
                                                                button: true
                                                            });
                                                        });
                                                    }}
                                                >
                                                    Sync VOA
                                                </Button>
                                            </React.Fragment>
                                        )}
                                        {run && oet && status === 5 && (
                                            <Button
                                                color="primary"
                                                type="button"
                                                title={run.disable_pr_action}
                                                disabled={run.disable_pr_action}
                                                onClick={ev => {
                                                    startPRValidation(
                                                        oet.id,
                                                        run.id,
                                                        run.pr_validation.id,
                                                        (success, data) => {
                                                            let mgs = data.detail;
                                                            let buttons = {close: "Ok"};
                                                            swal({
                                                                title: "PR Validation",
                                                                text: mgs,
                                                                icon: data.type,
                                                                buttons: buttons
                                                            });
                                                        }
                                                    );
                                                }}
                                            >
                                                Start PR Validation
                                            </Button>
                                        )}
                                        {run && oet && status === 4 && file && utils.check_validation_type(oet.customer_purchase_order) &&(
                                            <Button
                                                color="primary"
                                                type="button"
                                                onClick={() => this.approveOfflineApproval()}
                                            >
                                                Approve offline approval
                                            </Button>
                                        )}
                                    </div>
                                </Form>
                            );
                        }}
                    </Formik>
                </div>
            </div>
        );
    }



    handleSubmit = (fn, data, {setSubmitting}) => {
        const res = {
            number: data.number,
            issuing_date: data.issuing_date,
            bp_open_work_order_ref_number: data.bp_open_work_order_ref_number,
            purchasing_group: data.purchasing_group,
            name: data.name,
            for_offer_number_created_in_csp: data.for_offer_number_created_in_csp,
            sap_top_wbs: data.sap_top_wbs,
            so_count: data.so_count,
            vpo_count: data.vpo_count,
            pr_approved_date: data.pr_approved_date,
            base_id: data.base_id
        };
        const data_request = {
            ...utils.clearObjectNulls(res),
            account_indicator: data.account_indicator ? data.account_indicator.value : '',
        }
        fn(data_request);
        setSubmitting(false);
    };
}
